import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IdentityAuthService } from '../../../../services/identity-auth/identity-auth.service';
import { ApiService } from '../../../../services/api/api.service';
import { NbToastrService } from '@nebular/theme';
import { FormBuilderControl } from '../../../../common/formbuilder/FormBuilderControl';
import { ViewType } from '../../../../framework/core/Enums';

@Component({
  selector: 'app-report-select',
  templateUrl: './report-select.component.html',
  styleUrls: ['./report-select.component.css']
})
export class ReportSelectComponent implements OnInit {
  public loading: boolean;
  public start1: any;
  public start2: any;
  public end1: any;
  public end2: any;
  public formField: FormBuilderControl = {
    controlType: { viewType: ViewType.Dropdown }
  }
  public autoCompleteData: any = {};
	constructor(private router?: Router,
		public auth?: IdentityAuthService,
		public apiService?: ApiService, private messageService?: NbToastrService) { }

	ngOnInit() {
	}

	public selectReport(bladeIndex) {

		var route = {}
		route["id_" + bladeIndex] = true;
		this.router.navigate(['reqreports/index', route]);
	}

	public downloadReport(index) {
		var url = '';
		var postData = null;
		switch (index) {
			case 4:
				url = '/api/reports/supplierOutstandingDocuments';
				break;
			case 5:
				url = '/api/reports/requisitionDetails';
				postData = { poStartDate: this.start2, poEndDate: this.end2, createStartDate: this.start1, createEndDate: this.end1 }
        break;
      case 6:
        url = '/api/reports/stockCodeHistory';
        postData = { poStartDate: this.start2, poEndDate: this.end2, createStartDate: this.start1, createEndDate: this.end1, stockItemId: this.autoCompleteData && this.autoCompleteData.stockItemSuppliers ? this.autoCompleteData.stockItemSuppliers[0].stockItem.id : null }
        break;
      case 7:
        url = '/api/reports/vwDeliveriesOutstandingScheduled';
        postData = { poStartDate: this.start2, poEndDate: this.end2, createStartDate: this.start1, createEndDate: this.end1 }
        break;
      case 8:
        url = '/api/reports/vwDeliveriesOutstandingReceived';
        postData = { poStartDate: this.start2, poEndDate: this.end2, createStartDate: this.start1, createEndDate: this.end1}
        break;
      case 9:
        url = '/api/reports/vwDeliveriesDetail';
        postData = { poStartDate: this.start2, poEndDate: this.end2, createStartDate: this.start1, createEndDate: this.end1 }
        break;
		}
		this.loading = true;
		if (postData) {
			this.apiService.post(url, postData)
				.subscribe(data => {
					this.loading = false;
					this.messageService.success('Report generated and download started', 'Action');
					const link = document.createElement('a');
					link.href = `${this.apiService.appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
					link.setAttribute('visibility', 'hidden');
					link.click();
				}, err => {
					this.loading = false;
					this.messageService.danger('Could not Export', 'Action');
				});
		}
		else {
			this.apiService.get(url)
				.subscribe(data => {
					this.loading = false;
					this.messageService.success('Report generated and download started', 'Action');
					const link = document.createElement('a');
					link.href = `${this.apiService.appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
					link.setAttribute('visibility', 'hidden');
					link.click();
				}, err => {
					this.loading = false;
					this.messageService.danger('Could not Export', 'Action');
				});
		}
	}

}
